import React from "react";
import {GridCell, gridConstants} from "../../Components/Grid";
import {
    Button, checkAndSetError,
    clearInputFormErrorFields,
    EmailField,
    InputForm,
    inputFormIsValid,
    useInputForm
} from "../../Components/Inputs";
import {Link} from "../../Components/Link";
import {locations} from "../../Utilities/Location";

interface PasswordRequestViewProps {
    handleEmailAsync: (email: string) => Promise<any>;
    isLoading: boolean;
    setWarnings: (val: string[]) => void;
}

export const PasswordRequestView: React.FC<PasswordRequestViewProps> = ({
                                 handleEmailAsync,
                                 isLoading,
                                 setWarnings
                             }) => {
    const form = useInputForm({email: ""});

    const isFormValid = () => {
        clearInputFormErrorFields(form);

        checkAndSetError([
            form.email,
        ]);

        let isValid = inputFormIsValid(form);

        if (!isValid)
            setWarnings(["Missing required items. Please review your responses and try submitting again."]);

        return isValid;
    };

    const handleClickSubmit = async () => {
        if (isFormValid()) {
            handleEmailAsync(form.email.value);
        }
    };

    return <>
        <InputForm name={"forgotPw"}>
            <GridCell>
                <p>Submit the email address associated with your account below.
                    You will receive an email with a link to update your password.</p>
            </GridCell>

            <EmailField {...form.email} />

            <GridCell>
                <Button
                    isPrimary
                    name="btnSubmit"
                    label={`Request Forgot Password Email`}
                    onClick={handleClickSubmit}
                    disabled={isLoading}
                />
            </GridCell>

            <GridCell small_columns={gridConstants.column.SIX}>
                <p>
                    <Link {...locations.SIGN_IN.link} />
                </p>
            </GridCell>

            <GridCell small_columns={gridConstants.column.SIX}>
                {
                    <p className={`align-right`}>
                        <Link {...locations.REGISTER.link} />
                    </p>
                }
            </GridCell>
        </InputForm>
    </>;
};
